var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.901,
    height: 12,
    viewBox: "0 0 11.901 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Copy",
    d: "M3.268,3.279a.518.518,0,0,1,.368-.154H8.49a.519.519,0,0,1,.368.154.527.527,0,0,1,.152.371v.544a.558.558,0,1,0,1.116,0V3.65a1.657,1.657,0,0,0-.479-1.167A1.629,1.629,0,0,0,8.49,2H3.636a1.63,1.63,0,0,0-1.157.483A1.657,1.657,0,0,0,2,3.65V8.544A1.657,1.657,0,0,0,2.479,9.71a1.629,1.629,0,0,0,1.157.483h.539a.563.563,0,0,0,0-1.125H3.636a.518.518,0,0,1-.368-.154.527.527,0,0,1-.153-.371V3.65A.527.527,0,0,1,3.268,3.279ZM6.891,7.456a.523.523,0,0,1,.521-.525h4.853a.523.523,0,0,1,.521.525V12.35a.523.523,0,0,1-.521.525H7.411a.523.523,0,0,1-.521-.525Zm.521-1.65a1.643,1.643,0,0,0-1.636,1.65V12.35A1.643,1.643,0,0,0,7.411,14h4.853A1.643,1.643,0,0,0,13.9,12.35V7.456a1.643,1.643,0,0,0-1.636-1.65Z",
    transform: "translate(-2 -2)",
    fill: "#888",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.88a6d2dcc05aaa9352e54ebc49aa5eed.svg";
export { ForwardRef as ReactComponent };